import { apiAddress } from "constants/apiAddress";
import { LocalStorageKeys } from 'constants/localStorageKeys';


interface EntrySchema {
    point_name: string;
    shown_name: string
    measured_values: string;
    description: string
}

interface DeviceFamily{
    device_name: string;
    data_schema: EntrySchema[];
    description: string
}


export const getAllDeviceFamilies = async () =>
    await fetch(`${apiAddress}/admins/device-family`, {
        method: "GET",
        headers:{
            "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`
            }})
        .then((response) => response.json())
        .catch((reason) => console.error(reason));


export const getSpecificDeviceFamily = async (device_family_id: number) =>
    await fetch(`${apiAddress}/admins/device-family/${device_family_id}`, {
        method: "GET",
        headers:{
            "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`
            }})
        .then((response) => response.json())
        .catch((reason) => console.error(reason));

        
export const addNewDeviceFamily = async (device_family: DeviceFamily) =>
    await fetch(`${apiAddress}/admins/device-family`, {
        method: 'POST',
        headers:{
        "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`,
        "Content-Type": "application/json"
        },
        body: JSON.stringify(device_family)
    })
    .then((response) => response.ok ? response.ok : false)
    .catch((reason) => console.error(reason));


export const modifyDeviceFamily = async (device_family_id: number, device_family: DeviceFamily) =>
    await fetch(`${apiAddress}/admins/device-family/${device_family_id}`, {
        method: 'PATCH',
        headers:{
        "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`,
        "Content-Type": "application/json"
        },
        body: JSON.stringify(device_family)
    })
    .then((response) => response.ok ? response.ok : false)
    .catch((reason) => console.error(reason));

export const deleteDeviceFamily = async (device_id: string) =>
    await fetch(`${apiAddress}/admins/device-family/${device_id}`, {
        method: 'DELETE',
        headers:{
        "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`
        }
    })
    .then((response) => response.ok ? response.ok : false)
    .catch((reason) => console.error(reason));